export default "__VITE_ASSET__RC$2CSWh__"